
<div class="flex items-center justify-center min-h-screen p-4">
  <div class="w-full max-w-md p-6">

<main class="flex min-h-screen">
  <!-- Sección izquierda con imagen -->
  <div class="hidden md:flex w-1/2 items-center justify-center bg-black">
    <img src="assets/images/register_one.png" alt="Banamex Ilustración" class="w-full h-full object-cover" />
  </div>

  <!-- Sección derecha con formulario -->
  <div class="w-full md:w-1/2 flex items-start md:items-center justify-center p-6 md:pt-6">
    <div class="w-full max-w-md">


    <!-- Título y subtítulo -->
    <div class="mb-4">
      <h2 class="headline-06 text-[#003746] mb-2">Ingresa tus datos</h2>
      <p class="paragraph-default text-[#303638]">
        Completa tu registro con tus datos.
      </p>
    </div>

    <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" class="space-y-4">

      <!-- Campos informativos (no editables) -->
      <mat-form-field appearance="fill" class="w-full">

        <mat-label>Nombre Completo</mat-label>
        <input matInput formControlName="nombre" readonly />
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-full">

        <mat-label>Póliza</mat-label>
        <input matInput formControlName="poliza" readonly />
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Vigencia</mat-label>
        <input matInput type="date" formControlName="fecha_vigencia" readonly />
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Email</mat-label>
        <mat-icon matPrefix>email</mat-icon>
        <input matInput type="email" formControlName="correo" readonly />
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Fecha de nacimiento</mat-label>
        <input matInput [matDatepicker]="birthDatePicker" [max]="maxBirthDate" formControlName="fechaNacimiento">
        <mat-datepicker-toggle matIconSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #birthDatePicker></mat-datepicker>
        <mat-error *ngIf="registerForm.get('fechaNacimiento')?.hasError('required')">
          Campo obligatorio
        </mat-error>
        <mat-error *ngIf="registerForm.get('fechaNacimiento')?.hasError('underAge')">
          Debe ser mayor de 18 años
        </mat-error>
      </mat-form-field>

      <!-- Campos editables -->
       <p class="paragraph-default text-[#303638]">Selecciona el producto con el que diste de alta tu póliza.</p>
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Producto</mat-label>
        <mat-select formControlName="producto">
          <mat-option *ngFor="let producto of productos" [value]="producto.value">
            {{ producto.viewValue }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="registerForm.get('producto')?.hasError('required')">
          Campo obligatorio
        </mat-error>
      </mat-form-field>


      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Fecha de nacimiento</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="fecha_nacimiento">
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="registerForm.get('fecha_nacimiento')?.hasError('required')">
          Campo obligatorio
        </mat-error>
      </mat-form-field>


      <h2 class="headline-04 text-[#003746] my-2">Vigencia de tu póliza</h2>
      <p class="paragraph-default text-[#303638] mb-4">Selecciona la fecha de inicio y fin de tu póliza.</p>

      <!-- Campos de fecha -->
      <div class="flex gap-2">
        <mat-form-field appearance="fill" class="flex-1">
          <mat-label>Fecha de inicio</mat-label>
          <input matInput [matDatepicker]="startPicker" formControlName="fechaInicio">
          <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
          <mat-error *ngIf="registerForm.get('fechaInicio')?.hasError('required')">
            Campo obligatorio
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="flex-1">
          <mat-label>Fecha de fin</mat-label>
          <input matInput [matDatepicker]="endPicker" formControlName="fechaFin" readonly>
          <mat-datepicker-toggle matIconSuffix [for]="endPicker" disabled></mat-datepicker-toggle>
          <mat-datepicker #endPicker disabled></mat-datepicker>
          <mat-error *ngIf="registerForm.get('fechaFin')?.hasError('required')">
            Campo obligatorio
          </mat-error>
          <mat-error *ngIf="registerForm.get('fechaFin')?.hasError('dateRange')">
            La fecha de fin debe ser mayor a la fecha de inicio
          </mat-error>
          <mat-error *ngIf="registerForm.get('fechaFin')?.hasError('pastDate')">
            La fecha de fin no puede ser anterior al día actual
          </mat-error>
        </mat-form-field>
      </div>


      <!-- Teléfono con prefijo -->
      <div class="flex gap-2">
        <mat-form-field appearance="fill" class="w-32">
          <mat-select [(value)]="selectedLada">
            <mat-select-trigger>
              <div class="flex items-center">
                <img *ngIf="selectedLada" [src]="selectedLada.img" width="20" class="mr-2" />
                <span>{{ selectedLada?.name }}</span>
              </div>
            </mat-select-trigger>
            <mat-option *ngFor="let lada of ladaList" [value]="lada">
              <div class="flex items-center">
                <img [src]="lada.img" width="20" class="mr-2" />
                <span>{{ lada.name }}</span>
              </div>
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" class="flex-1">
          <mat-label>Número de teléfono</mat-label>
          <input matInput type="tel" formControlName="telefono" #telefonoInput
                 pattern="[0-9]*" inputmode="numeric" maxlength="10"
                 (keypress)="onKeyPress($event)" (input)="onPhoneInput($event)"
                 autocomplete="new-password"
                 data-lpignore="true"
                 data-form-type="other"
                 data-1p-ignore="true"
                 data-bwignore="true"
                 readonly onfocus="this.removeAttribute('readonly');" />
          <mat-error *ngIf="registerForm.get('telefono')?.hasError('required')">
            Campo obligatorio
          </mat-error>
          <mat-error *ngIf="registerForm.get('telefono')?.hasError('pattern')">
            Ingrese un número de 10 dígitos
          </mat-error>
        </mat-form-field>

      </div>


      <!-- Opciones de contacto -->
      <div class="mt-6">
        <h2 class="headline-04 text-[#003746] mb-2">Elige un método de contacto</h2>
        <h3 class="paragraph-default text-[#303638]">Es el canal que utilizaremos para compartirte comunicados y registros de tus solicitudes.</h3>

        <mat-checkbox formControlName="contacto_email" class="block mb-2">
          Correo electrónico
        </mat-checkbox>

        <mat-checkbox formControlName="contacto_whatsapp" class="block mb-2">
          WhatsApp
        </mat-checkbox>

        <mat-checkbox formControlName="contacto_telefono" class="block mb-2">
          Teléfono
        </mat-checkbox>
      </div>

      <!-- Sección de contraseña -->
      <div class="mt-2">
        <h2 class="headline-04 text-[#003746] mb-2">Crea una contraseña</h2>
        <p class="paragraph-default text-[#303638] mb-1">Deberá tener más de 12 caracteres, mayúsculas, minúsculas, números y símbolos.</p>

        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Crea tu contraseña</mat-label>
          <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" />
          <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-error *ngIf="registerForm.get('password')?.hasError('required')">
            Campo obligatorio
          </mat-error>
        </mat-form-field>

        <!-- Strength Checklist -->
        <div style="font-size: 13px; margin-bottom: 5px;">
          <div [style.color]="hasMinLength() ? 'green' : 'red'">✔ Más de 12 caracteres</div>
          <div [style.color]="hasNumber() ? 'green' : 'red'">✔ Incluye número</div>
          <div [style.color]="hasUppercase() ? 'green' : 'red'">✔ Incluye una letra Mayúscula</div>
          <div [style.color]="hasSpecialChar() ? 'green' : 'red'">✔ Incluye un carácter especial ($!%*?&+-_)</div>
        </div>

        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Confirma tu contraseña</mat-label>
          <input matInput [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="confirmPassword" />
          <button mat-icon-button matSuffix (click)="hideConfirmPassword = !hideConfirmPassword" type="button">
            <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-error *ngIf="registerForm.get('confirmPassword')?.hasError('required')">
            Campo obligatorio
          </mat-error>
          <mat-error *ngIf="registerForm.get('confirmPassword')?.hasError('mismatch')">
            Las contraseñas no coinciden
          </mat-error>
        </mat-form-field>

        <!-- Metodo de contacto -->
        <div class="mt-3">
          <h2 class="headline-04 text-[#003746] mb-2">Elige un método de contacto</h2>
          <p class="paragraph-default text-[#303638] mb-4">Es el canal que utilizaremos para compartirte comunicados y registros de tus solicitudes.</p>

          <mat-radio-group formControlName="metodoContacto" class="space-y-3 flex flex-col">
            <mat-radio-button value="1">
              Correo electrónico
            </mat-radio-button>

            <mat-radio-button value="2">
              WhatsApp
            </mat-radio-button>

            <mat-radio-button value="2">
              Teléfono
            </mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="registerForm.get('metodoContacto')?.hasError('required') && registerForm.get('metodoContacto')?.touched">
            Debe seleccionar un método de contacto
          </mat-error>
        </div>

      </div>

      <p class="text-[var(--login-p,#3D4E5F)] text-center m-3">Los campos con * son obligatorios.</p>

      <!-- Botón principal -->
      <button
        type="submit"
        class="w-full mt-6 py-3 rounded-full font-medium transition-colors bg-[#052631] text-white hover:bg-[#041f28]">
        Siguiente
      </button>
    </form>
  </div>
</div>
